<template>
  <div class="con" :class="{ 'full-h': currentListLength == 0 }">
    <freesearchSortResults :searchId="searchId" />

    <noResultsInList
      :text="getTextSearch"
      v-if="currentListLength == 0 && !searching"
    />
    <div
      :id="'the-free-book-list_' + searchId"
      ref="el"
      @keydown="scrollList($event)"
      @keyup="generalShortsUp"
      @mouseenter="addKey"
      class="list-book"
      :class="{ 'h-100': $_mobile }"
      v-show="currentListLength > 0"
      tabindex="0"
    >
      <RecycleScroller
        v-if="false"
        ref="listScroller"
        :buffer="180"
        style="height: 100%; direction: ltr"
        :items="list"
        :item-size="37"
        v-slot="{ item, index, active }"
        class="rec-scroller"
        @mouseenter="$emit('mouseenter', $event)"
        @wheelScroll="wheelScroll"
      >
        <itemBook
          :index="i"
          :inx="index"
          type="free"
          :book="item"
          :searchMode="true"
          :checked="getBooksChecked[item.id]"
          @gzirim="toggleGzirim(item.index)"
          @gzir="recalcScroll"
          @selected="selectItem"
          :select="select"
          :gzirim="getGzirim[item.index]"
          :startResult="startResult"
          :endResult="endResult"
          :lastItem="i == endBook - startBook"
          :active="activeBook"
          :listIndex="index"
          @lastCheck="setLastCheck"
          @shiftCheck="doShiftCheck"
          @updateActive="updateLastActive"
          :activeInScroll="active"
        />
      </RecycleScroller>

      <fsFakeScrollBar
        v-if="!isSpecialResults && !getHideBookLists"
        ref="fsscroll"
        :startBook="startBook"
        :startResult="startResult"
        :endBook="endBook"
        :endResult="endResult"
        :startRender="startRender"
        :endRender="endRender"
        :listLength="listLength"
        :numBooks="numBooks"
        :listTop="listTop"
        @calcScroll="calcScroll"
        :newList="newList"
        @wheelScroll="wheelScroll"
        :scrollTo="scrollListTo"
        :searchId="searchId"
      >
        <template v-slot:default>
          <div
            class="item-book-out"
            v-for="(book, i) in list.slice(startBook - 1, endBook)"
            :key="book.id + i.toString() + currentFsName"
          >
            <itemBook
              :searchId="searchId"
              :index="i"
              type="free"
              :book="book"
              :searchMode="true"
              :mefo="mefo"
              :checked="getBooksChecked[book.id]"
              @gzirim="toggleGzirim(book.index)"
              @gzir="recalcScroll"
              @selected="selectItem"
              :select="select"
              :gzirim="getGzirim[book.index]"
              :startResult="startResult"
              :endResult="endResult"
              :lastItem="i == endBook - startBook"
              :active="activeBook"
              :listIndex="i + startBook - 1"
              @lastCheck="setLastCheck"
              @shiftCheck="doShiftCheck"
              @updateActive="updateLastActive"
              @scrolltosec="scrollToSection"
            />
          </div>
        </template>
      </fsFakeScrollBar>
      <fakeScrollBar
        @wheelScroll="wheelScroll"
        v-if="isSpecialResults && !getHideBookLists"
        ref="fsspecscroll"
        :lengthArray="listLength"
        :maxViewList="maxViewList"
        :heightItem="itemBookHeight"
        :startAt="startList"
        :newList="newList"
      >
        <template v-slot:default="data">
          <div
            class="item-book-out"
            v-for="(book, index) in list.slice(data.startAt, data.endAt)"
            :key="book.id + '-' + index"
          >
            <itemBook
              :searchId="searchId"
              :resultType="book.resultType"
              :result="book.result"
              :searchMode="true"
              type="free"
              :book="book.special ? book.book : book"
              :page="book.special ? book.page : null"
              :active="activeBook"
              :activeinx="activeBookIndex"
              :inx="book.special ? book.page : null"
              @selected="selectItem"
              :select="select"
              :checked="getBooksChecked[book.id]"
              @open="setActiveData"
              :listIndex="index + data.startAt"
              @lastCheck="setLastCheck"
              @shiftCheck="doShiftCheck"
              @updateActive="updateLastActive"
            />
          </div>
        </template>
      </fakeScrollBar>
    </div>
    <freeSearchListStatusBar :searchId="searchId" />
  </div>
</template>

<script>
import { bookList } from "@/mixing/mixBookList.js";
import { mapGetters, mapState, mapActions } from "vuex";
import freesearchSortResults from "./freesearchSortResults.vue";
import * as freeSearchBookListComp from "@/store/modules/componentModules/freeSearchBookListComp";
import fsFakeScrollBar from "@/components/FreeSearch/FSfakeScrollBar.vue";
import bookwin from "@/services/book_win.js";
import config from "@/config/general";
import { openBook as open } from "@/services/bookData.js";
import { createFreeSearchBookListStore } from "@/store_pinia";
let gzirimHeader = 30;
let timeout;
let marginSize = 0;
let lastKnowMode = false;
export default {
  mixins: [bookList],
  props: ["search", "mefo", "searchId"],
  data() {
    return {
      maxViewList: 100,
      endList: 100,
      startList: 0,
      newList: 0,
      startBook: 0,
      startResult: 0,
      endBook: 0,
      endResult: 0,
      startRender: 0,
      endRender: 0,
      maxRenderHeight: 3000,
      maxRenderGzirim: 8,
      dorot: [
        'מקרא וחז"ל',
        "ראשונים וקדמונים",
        'אחרונים ש-ת"ר',
        'אחרונים ת"ר -ת"ש',
        "אחרוני זמנינו",
        "אחרים",
      ],
      listLength: 0,
      numBooks: 0,
      listTop: 0,
      select: null,
      activeBook: null,
      activeBookIndex: null,
      indexActive: null,
      lastCheck: 0,
      indexUpdateTimer: null,
      lastListIndex: -1,
      scrollListTo: 0,
    };
  },
  components: {
    freesearchSortResults,
    fsFakeScrollBar,
  },
  computed: {
    ...mapState("bookList", ["showHiddenBooks"]),
    ...mapState("freeSearch", ["searching"]),
    ...mapState("booklistComp", ["firstFreeActive"]),
    ...mapGetters("tabsManager", ["getCurrentBook"]),
    ...mapGetters("mefo", ["getSectionBookPages"]),
    freeSearchBookListStore() {
      return createFreeSearchBookListStore(this.searchId);
    },
    getFreeSearchBookListStore() {
      return this.freeSearchBookListStore || {};
    },
    getCurrentList() {
      return (
        this.getFreeSearchBookListStore.getCurrentList || { booksList: [] }
      );
    },
    getBooksChecked() {
      return this.getFreeSearchBookListStore.getBooksChecked;
    },
    getGzirim() {
      return this.getFreeSearchBookListStore.getGzirim;
    },
    getHideBookLists() {
      return this.getFreeSearchBookListStore.hideBookLists;
    },
    getTextSearch() {
      return this.getFreeSearchBookListStore.textSearch;
    },
    getDataOfCurrentList() {
      return this.getFreeSearchBookListStore.getDataOfCurrentList;
    },
    listFromSearchIn() {
      return this.getFreeSearchBookListStore.listFromSearchIn;
    },
    currentListLength() {
      return this.getFreeSearchBookListStore.currentListLength;
    },
    dontScroll() {
      return this.getFreeSearchBookListStore.dontScroll;
    },
    gzirimMode() {
      return this.freeSearchBookListStore.gzirimMode;
    },
    dontLoadGzirim() {
      return this.getFreeSearchBookListStore.dontLoadGzirim;
    },
    resultsType() {
      return this.getFreeSearchBookListStore.resultsType;
    },
    currentFsName() {
      return this.getFreeSearchBookListStore.currentFsName;
    },
    isSpecialResults() {
      return this.resultsType === "special";
    },
    itemBookHeight() {
      return this.userSettings.settings.bookItemSize != "compact" ? 37 : 25;
    },
    list() {
      let list = this.getCurrentList;
      if (!list) return [];
      let react = this.$store.state.booksChanged;

      list = list.booksList;
      if (this.isSpecialResults) this.listLength = list.length;
      else this.calcListLength();
      this.numBooks = list.length;
      return list;
    },
  },
  watch: {
    getCurrentList: function (newv, old) {
      if (!newv) return;
      if (!this.isSpecialResults && !this.getHideBookLists) {
        this.$nextTick(() => {
          if (this.$refs.fsscroll === undefined) return;
          if (
            old.booksList == newv.booksList &&
            this.gzirimMode == lastKnowMode
          )
            return;
          lastKnowMode = this.gzirimMode;
          this.calcListLength();
          const fsscroll = this.$refs.fsscroll.$el;

          if (!this.dontScroll) {
            this.calcScroll(fsscroll.scrollTop);
            this.newList++;
          }

          this.setDontScroll(false);
          let lastActive = 0;
          if (!this.listFromSearchIn) {
            lastActive = this.getDataOfCurrentList.currentLastActive;
            if (!lastActive || lastActive == -1) lastActive = 0;
          }
          this.startList = lastActive;
          this.$store.state.currentActiveListIndex = lastActive.toString();
          this.$store.state.lastActiveList = 2;
          if (
            (newv.booksList.length &&
              this.freeSearchBookListStore.id == "main") ||
            this.freeSearchBookListStore.getFirstTimeSearch
          ) {
            this.clickBook(false, true);
            this.freeSearchBookListStore.setFirstTimeSearch(false);
          }

          this.$nextTick(() => {
            this.scrollListTo =
              parseInt(this.$store.state.currentActiveListIndex) *
              this.itemBookHeight;
          });

          if (!this.listFromSearchIn) {
            let el = document.getElementById(
              `the-free-book-list_${this.searchId}`
            );
            if (!el) return;
            el.focus();
          } else {
            this.setListFromSearchIn(true);
          }
        });
      }
    },
    dontLoadGzirim: function (val, oVal) {
      if (val == true) {
        this.startBook = 0;
        this.endBook = 0;
        this.setDontLoadGzirim(false);
        if (this.freeSearchBookListStore)
          this.freeSearchBookListStore.booksIdsRefresh++;
      }
    },
    firstFreeActive: function (val) {
      if (!val) return;
      this.$store.state.currentActiveListIndex = "0";
      this.$store.state.lastActiveList = 2;
      this.setFirstFreeActive(false);
      if (this.list.length == 0) return;
      //  this.activeBook = this.list[0].id;
      this.indexActive = 0;

      let el = this.$refs.el;
      if (!el) return;
      el.focus();
      /*  if (val !== true)
        if (this.$refs.el)
          //we come from down key on search input
          el.focus(); */
      el = el.querySelector(".list-book-inner");

      el.scrollTop = 0;
      this.scrollList({ code: "DOWN", getModifierState: () => false });
    },
  },
  methods: {
    ...mapActions("booklistComp", ["setFirstFreeActive"]),
    ...mapActions("userSearchHistory", ["setLastActive"]),
    setDontLoadGzirim(payload) {
      this.freeSearchBookListStore.dontLoadGzirim = payload;
    },
    setListFromSearchIn(payload) {
      this.freeSearchBookListStore.setListFromSearchIn(payload);
    },
    setDontScroll(val) {
      this.freeSearchBookListStore.dontScroll = val;
    },
    checkBook(payload) {
      this.freeSearchBookListStore.checkBook(payload);
    },
    toggleCheck(payload) {
      this.freeSearchBookListStore.toggleCheckBook(payload);
    },
    updateCurrentListLastIndex(payload) {
      this.freeSearchBookListStore.updateCurrentListLastIndex(payload);
    },
    scrollToSection(book) {
      if (this.mefo) {
        let secsData = this.getSectionBookPages;
        // search book in sections map
        const books = [];
        for (const [key, value] of secsData) {
          Object.entries(value).forEach(([okey, ovalue]) => {
            if (okey == book) books.push(ovalue);
          });
        }
        this.$emit("scrollToSec", Math.min(...books.map((book) => book.index)));
      }
    },
    updateLastActive(inx) {
      let _vm = this;

      if (
        this.lastListIndex == -1 ||
        this.lastListIndex == this.getDataOfCurrentList.current
      )
        clearTimeout(this.indexUpdateTimer);
      this.indexUpdateTimer = setTimeout(() => {
        const data = {
          listId: _vm.getDataOfCurrentList.current,
          index: inx,
        };

        this.updateCurrentListLastIndex(data);
        this.setLastActive(data);
      }, 1000);

      this.lastListIndex = this.getDataOfCurrentList.current;
    },
    setLastCheck(index) {
      this.lastCheck = index;
    },
    doShiftCheck(index) {
      let start = this.lastCheck;
      let end = index;
      if (start > end) {
        end = start;
        start = index;
      }

      for (let i = start; i <= end; i++) {
        let book = this.list[i];
        this.checkBook({ book: book.id, check: true });
      }
      this.lastCheck = 0;
    },
    move(num, page = false) {
      try {
        let multiple = 1;
        if (page) {
          let numBooksInView = Math.floor(
            this.$refs.el.clientHeight / this.itemBookHeight
          );
          multiple = numBooksInView - 1;
        }
        let gotoIndex;
        if (this.isSpecialResults) {
          gotoIndex = (
            parseInt(this.$store.state.currentActiveListIndex) +
            num * multiple
          ).toString();
        } else {
          //check if active is gzir
          if (!isGzirIndex(this.$store.state.currentActiveListIndex)) {
            //not gzir, check if gzirim are open
            if (num > 0) {
              //scrolling down
              let item =
                this.getCurrentList.booksList[
                  parseInt(this.$store.state.currentActiveListIndex)
                ];
              if (item.fs.bookref.gzirim) {
                gotoIndex = this.$store.state.currentActiveListIndex + ".1";
              } else
                gotoIndex = (
                  parseInt(this.$store.state.currentActiveListIndex) +
                  num * multiple
                ).toString();
            } else {
              //scrolling up
              let item =
                this.getCurrentList.booksList[
                  parseInt(this.$store.state.currentActiveListIndex) +
                    num * multiple
                ];

              if (item.fs.bookref.gzirim) {
                {
                  let indexInStr =
                    (
                      parseInt(this.$store.state.currentActiveListIndex) +
                      num * multiple
                    ).toString() +
                    "." +
                    item.fs.bookref.results.toString();
                  gotoIndex = indexInStr; // parseFloat(indexInStr);
                }
                /*  gotoIndex =
                  this.$store.state.currentActiveListIndex +
                  num * multiple +
                  item.fs.bookref.results / 10; */
              } else
                gotoIndex =
                  parseInt(this.$store.state.currentActiveListIndex) +
                  num * multiple;
            }
          } else {
            //is gzir
            let str = this.$store.state.currentActiveListIndex;
            let gzirInd = parseInt(str.split(".")[1]);
            let bookInd = parseInt(str.split(".")[0]);
            let item = this.getCurrentList.booksList[bookInd];

            if (num > 0) {
              //scrolling down
              if (gzirInd === item.fs.bookref.results) {
                gotoIndex = bookInd + 1;
                if (gotoIndex > this.list.length - 1)
                  gotoIndex = this.$store.state.currentActiveListIndex;
              } else {
                let indexInStr =
                  bookInd.toString() + "." + (gzirInd + 1).toString();
                gotoIndex = indexInStr; // parseFloat(indexInStr);

                /*  gotoIndex =
                  Math.round(
                    (this.$store.state.currentActiveListIndex + 0.1) * 100
                  ) / 100; */
              }
              //gotoIndex = this.$store.state.currentActiveListIndex + 0.1;
            } //scrolling up
            else {
              if (gzirInd === 1) gotoIndex = bookInd;
              else {
                let indexInStr =
                  bookInd.toString() + "." + (gzirInd - 1).toString();
                gotoIndex = indexInStr; // parseFloat(indexInStr);
              }
              /* gotoIndex =
                  Math.round(
                    (this.$store.state.currentActiveListIndex - 0.1) * 100
                  ) / 100; */
              //gotoIndex = this.$store.state.currentActiveListIndex - 0.1;
            }
          }
        }

        if (gotoIndex < 0) gotoIndex = 0;
        else {
          if (!isGzirIndex(gotoIndex.toString()))
            if (gotoIndex > this.list.length - 1)
              gotoIndex = this.list.length - 1;
        }

        this.$store.state.currentActiveListIndex = gotoIndex.toString();
      } catch (ex) {}
    },
    scrollToElementIfNeeded(dir = "down") {
      let calcScroll;
      let list = this.$refs.el;
      list = list.querySelector(".list-book-inner");
      if (!list) return;

      let itemsContainer = list.querySelector(".items-container");
      if (itemsContainer == null) itemsContainer = list;
      let itemsContainerTop = itemsContainer.offsetTop;
      let top = itemsContainerTop;
      let selector = "";
      if (!isGzirIndex(this.$store.state.currentActiveListIndex)) {
        if (dir === "down")
          selector = `.item-book#freebook_${this.$store.state.currentActiveListIndex}`;
        else
          selector = `.item-book#freebook_${this.$store.state.currentActiveListIndex}`;
      } else {
        let str = this.$store.state.currentActiveListIndex;
        let gzirInd = str.split(".")[1];
        let bookInd = str.split(".")[0];
        let list = this.$refs.el;
        selector = ".gzir#freebook_" + bookInd + "_" + (parseInt(gzirInd) - 1);
      }
      if (dir === "down") {
        let elem = list.querySelector(selector);
        if (!elem) {
          if (!isGzirIndex(this.$store.state.currentActiveListIndex)) {
            /*  list.scrollTop =
              this.$store.state.currentActiveListIndex * itemBookHeight; */
            list.scrollTop = this.scrollToItem(
              this.$store.state.currentActiveListIndex
            );
          } else {
            let str = this.$store.state.currentActiveListIndex.toString();
            let gzirInd = parseInt(str.split(".")[1]);
            let bookInd = parseInt(str.split(".")[0]);
            list.scrollTop = this.scrollToItem(bookInd, gzirInd);
          }
          return;
        }

        let height = list.offsetHeight;
        let offset = top + height;
        let topElem = elem.offsetTop; //- list.scrollTop + elem.offsetHeight; //* 2;
        calcScroll = offset - (elem.offsetTop - list.scrollTop);

        let elemOffSet = elem.offsetTop + itemsContainerTop + elem.offsetHeight;
        let listTop = list.scrollTop + list.offsetHeight;
        if (listTop <= elemOffSet) {
          list.scrollTop = elemOffSet - this.$refs.el.clientHeight; // + elem.offsetHeight; // - elem.offsetHeight);
          // ;
          /*  list.scrollTop =
            topElem - this.$refs.el.clientHeight - elem.offsetHeight; */
        }
      } else {
        //up
        let elem = list.querySelector(selector);
        if (!elem) {
          if (!isGzirIndex(this.$store.state.currentActiveListIndex)) {
            /*  list.scrollTop =
              this.$store.state.currentActiveListIndex * itemBookHeight; */
            list.scrollTop = this.scrollToItem(
              this.$store.state.currentActiveListIndex
            );
          } else {
            let str = this.$store.state.currentActiveListIndex;
            let gzirInd = parseInt(str.split(".")[1]);
            let bookInd = parseInt(str.split(".")[0]);
            list.scrollTop = this.scrollToItem(bookInd, gzirInd);
          }
          return;
        }

        let elemOffSet = elem.offsetTop + itemsContainerTop;
        let listTop = list.scrollTop;
        if (listTop >= elemOffSet) {
          /* if (offset < topElem) { */
          /*  list.scrollTop =
            (this.$store.state.currentActiveListIndex - numBooksInView + 1) *
            itemBookHeight; */
          /*  list.scrollTop =
            elem.offsetTop - (this.$refs.el.clientHeight - elem.offsetHeight); // this.$refs.el.clientHeight; */
          list.scrollTop = elemOffSet - elem.offsetHeight + elem.offsetHeight;
        }

        return;

        calcScroll = elem.offsetTop - list.scrollTop - top;
        if (
          top >
          elem.offsetTop +
            itemsContainerTop -
            list.scrollTop -
            elem.offsetHeight
        ) {
          list.scrollTop =
            this.$store.state.currentActiveListIndex * itemBookHeight;
        }
      }

      /*        if (dir == "down") {
        let height = el.offsetHeight;
        let offset = top + height;
        let topElem = elem.offsetTop - el.scrollTop + elem.offsetHeight * 2;
        calcScroll = offset - (elem.offsetTop - el.scrollTop);
        if (offset < topElem) {
          el.scrollTop =
            el.scrollTop + elem.offsetHeight + elem.offsetHeight - calcScroll;
        }
      } else if ((dir = "up")) {
        calcScroll = elem.offsetTop + -el.scrollTop - top;
        if (
          top >
          elem.offsetTop + itemsContainerTop - el.scrollTop - elem.offsetHeight
        ) {
          el.scrollTop -= elem.offsetHeight - calcScroll;
        }

      } */
    },
    scrollPage() {
      let el = this.$refs.el;
      let list = el.querySelector(".list-book-inner");
      list.scrollTop =
        parseInt(this.$store.state.currentActiveListIndex) *
        this.itemBookHeight;
    },
    setActiveData(data) {
      this.activeBook = data.bookId;
      this.activeBookIndex = data.page;
    },
    wheelScroll({ dir, delta }) {
      this.$store.state.lastActiveList = 2;
      let num = (dir === "down" ? 1 : -1) * delta;
      this.move(num);
      this.scrollToElementIfNeeded(dir);
      // this.elementInViewport(dir);
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.clickBook(false, true);
      }, 100);
    },
    recalcScroll() {
      const fsscroll = this.$refs.fsscroll.$el;

      this.calcScroll(fsscroll.scrollTop);
    },
    calcScroll(scroll) {
      let reachedScroll = false,
        reachedRangeEnd = false,
        length = 0,
        countResults = 0,
        countBooks = 0,
        totalCount = 0,
        fixedScroll = 0,
        gzirimCount = 0,
        _vm = this;
      this.startRender = scroll;
      // const gzirimData = [...this.getGzirim];
      const gzirimRealData = [...this.getCurrentList.booksList];
      var j = 0;
      for (j = 0; j < gzirimRealData.length; j++) {
        if (reachedRangeEnd) break;
        // let element2 = gzirimData[j];

        let bookElement = gzirimRealData[j];
        let element = bookElement.fs.bookref;

        if (
          !(
            bookElement.name.includes(this.search) ||
            bookElement.mainAuthorName.includes(this.search) ||
            this.search == ""
          )
        )
          continue;

        //  let element = gzirimRealData[j].fs.bookref;
        length += this.itemBookHeight;
        countBooks++;
        if (length >= scroll - marginSize && !reachedScroll) {
          _vm.listTop = length - this.itemBookHeight;
          reachedScroll = true;
          fixedScroll = length;
          _vm.startBook = countBooks;
          _vm.startResult = 0;
          length = 0;
        } else {
          if (
            reachedScroll &&
            length >= _vm.maxRenderHeight + marginSize &&
            !reachedRangeEnd
          ) {
            reachedRangeEnd = true;
            _vm.endRender = scroll + length;
            _vm.endBook = countBooks;
            _vm.endResult = 0;
            break;
          }
        }
        // const show = element.show;
        const show = element.gzirim ? element.gzirim : false;
        if (show) {
          countResults = 0;
          _vm.endResult = 0;
          for (var i = 0; i < element.results; i++) {
            length +=
              config.gzirHeight[
                this.userSettings.settings.height_gzir
                  ? this.userSettings.settings.height_gzir
                  : "low"
              ] + gzirimHeader;
            countResults++;
            if (length >= scroll - marginSize && !reachedScroll) {
              //  _vm.listTop = length - 130;
              _vm.listTop =
                length -
                config.gzirHeight[
                  this.userSettings.settings.height_gzir
                    ? this.userSettings.settings.height_gzir
                    : "low"
                ] -
                gzirimHeader;

              reachedScroll = true;
              fixedScroll = length;
              _vm.startBook = countBooks;
              _vm.startResult = countResults - 1;
              _vm.endResult = countResults - 1;
              length = 0;
            } else {
              if (
                ((reachedScroll &&
                  length >= _vm.maxRenderHeight + marginSize) ||
                  gzirimCount >= _vm.maxRenderGzirim) &&
                !reachedRangeEnd
              ) {
                reachedRangeEnd = true;
                _vm.endRender = scroll + length;

                _vm.endBook = countBooks;
                _vm.endResult = countResults;
                break;
              }
            }
            if (reachedScroll) gzirimCount++;
          }
        }
      }
      if (j == gzirimRealData.length) {
        this.endBook = gzirimRealData.length;
        this.endResult = countResults - 1;
        this.endRender = scroll + length;
      }
    },
    calcListLength() {
      let length = 0;
      let _vm = this;
      // const gzirimData = [...this.getGzirim];
      // const gzirimData = [...this.getCurrentList.booksList];
      const gzirimRealData = [...this.getCurrentList.booksList];
      for (var j = 0; j < gzirimRealData.length; j++) {
        let bookElement = gzirimRealData[j];
        let element = bookElement.fs.bookref;

        if (
          !(
            bookElement.name.includes(this.search) ||
            bookElement.mainAuthorName.includes(this.search) ||
            this.search == ""
          )
        )
          continue;

        // let element = gzirimData[j];
        length += this.itemBookHeight;
        const show = element.gzirim ? element.gzirim : false;
        if (show) {
          for (var i = 0; i < element.results; i++) {
            length +=
              config.gzirHeight[
                this.userSettings.settings.height_gzir
                  ? this.userSettings.settings.height_gzir
                  : "low"
              ] + gzirimHeader;
          }
        }
      }

      this.listLength = length;
    },
    scrollToItem(bookInd, gzirInd) {
      bookInd = parseInt(bookInd);
      let length = 0;
      let _vm = this;
      const gzirimRealData = [...this.getCurrentList.booksList];
      for (var j = 0; j < bookInd; j++) {
        let bookElement = gzirimRealData[j];
        let element = bookElement.fs.bookref;

        if (
          !(
            bookElement.name.includes(this.search) ||
            bookElement.mainAuthorName.includes(this.search) ||
            this.search == ""
          )
        )
          continue;

        // let element = gzirimData[j];
        length += this.itemBookHeight;
        const show = element.gzirim ? element.gzirim : false;
        if (show) {
          let gzirToGo = element.results;
          if (j === bookInd - 1 && gzirInd != undefined) gzirToGo = gzirInd;
          for (var i = 0; i < gzirToGo; i++) {
            length +=
              config.gzirHeight[
                this.userSettings.settings.height_gzir
                  ? this.userSettings.settings.height_gzir
                  : "low"
              ] + gzirimHeader;
          }
        }
      }
      return length;
    },
    bookChecked(id) {
      let x = this.getCurrentListIds.filter((b) => b.book == id);
      return x.checked == undefined ? false : x.checked;
    },

    sortValue(book) {
      return book.sortValue == undefined ? 0 : book.sortValue;
    },
    sortByProfile(list) {
      let customSortBooks = freeSearchBookListComp.customSortBooks;
      try {
        list.forEach((book, index, arr) => {
          customSortBooks.forEach((sort, sortIndex) => {
            let bookid = sort.get(sort.root, book.id);
            if (bookid) {
              arr[index].sortValue = sortIndex + 1;
            } else arr[index].sortValue = 0;
          });
        });
        return list;
      } catch (ex) {
        console.error(ex.message);
      }
    },
    selectItem(id) {
      this.select = id;
    },
    async generalShortsUp(event) {
      switch (event.code) {
        case "ShiftLeft":
        case "ShiftRight":
          this.$store.state.shiftPress = false;
          break;
      }
    },
    openBookInNewWindow(book, fsData) {
      bookwin.createWinBook(
        book,
        fsData == undefined ? 1 : -1,
        null,
        null,
        null,
        null,
        fsData
      );
    },
    scrollList(event) {
      let currIndex = this.$store.state.currentActiveListIndex;
      let nothing = false;
      try {
        event.stopPropagation();
        event.preventDefault();
      } catch (ex) {}
      // alert("scroll top");
      // switch (event.srcKey) {
      let dir;
      const NumLockEnabled = event.getModifierState
        ? event.getModifierState("NumLock")
        : false;

      switch (event.code) {
        case "Enter":
          let bookItem =
            this.list[parseInt(this.$store.state.currentActiveListIndex)];
          this.openBookInNewWindow(bookItem.id, bookItem.fs);
          break;
        case "Space":
          let book =
            this.list[parseInt(this.$store.state.currentActiveListIndex)];
          this.toggleCheck({ book: book.id });
          this.move(1);
          this.scrollToElementIfNeeded();

          break;
        case "ShiftLeft":
        case "ShiftRight":
          this.$store.state.shiftPress = true;
          break;

        case "F2":
          event.preventDefault();
          event.stopPropagation();
          this.$store.state.bookList.setFocusInInput++;
          break;
        case "F3":
          event.preventDefault();
          event.stopPropagation();
          this.freeSearchBookListStore.focusInInput++;
          break;
        case "Tab":
          if (!event.shiftKey && !event.ctrlKey) {
            event.preventDefault();
            event.stopPropagation();
            let bookElement = document.getElementById(
              `the-book${this.$store.state.tabsManager.currentTabId}`
            );
            document
              .getElementById(`the-free-book-list_${this.searchId}`)
              .blur();
            if (bookElement) bookElement.focus();
          }
          break;
        case "PageDown":
        case "Numpad3":
          if (event.code == "Numpad3" && NumLockEnabled) break;
          this.move(1, true);
          this.scrollPage();
          break;
        case "PageUp":
        case "Numpad9":
          if (event.code == "Numpad9" && NumLockEnabled) break;
          this.move(-1, true);
          this.scrollPage();
          break;
        case "Numpad8":
          if (event.code == "Numpad8" && NumLockEnabled) break;
          // this.setActive("up");
          //dir = "up";
          this.move(-1);
          this.scrollToElementIfNeeded("up");
          break;
        case "Numpad2":
          // this.setActive("down");
          //  dir = "down";
          if (event.code == "Numpad2" && NumLockEnabled) break;
          this.move(1);
          this.scrollToElementIfNeeded();
          break;
        case "ArrowUp":
          // {
          //   this.setActive("up");
          //   dir = "up";
          // }
          this.move(-1);
          this.scrollToElementIfNeeded("up");
          break;
        case "ArrowDown":
          // {
          //  this.setActive("down");
          //  dir = "down";
          // }
          this.move(1);
          this.scrollToElementIfNeeded();
          break;
        default:
          nothing = true;
      }
      if (nothing) return;
      //this.elementInViewport(dir);
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        if (currIndex != this.$store.state.currentActiveListIndex)
          this.clickBook(false, true);
      }, 200);
    },
    elementInViewport(dir) {
      let calcScroll;
      let el = this.$refs.el;

      el = el.querySelector(".list-book-inner");
      if (!el) return;
      let itemsContainer = el.querySelector(".items-container");
      let top = el.offsetTop;
      let itemsContainerTop = itemsContainer.offsetTop;
      itemsContainer;
      let elem = el.querySelector(".item-book.active");
      if (!elem) {
        elem = el.querySelector(".item-book");
        if (!elem) return;
        el.scrollTop = this.indexActive * elem.offsetHeight;
        return;
      }
      if (dir == "down") {
        let height = el.offsetHeight;
        let offset = top + height;
        let topElem = elem.offsetTop - el.scrollTop + elem.offsetHeight * 2;
        calcScroll = offset - (elem.offsetTop - el.scrollTop);
        if (offset < topElem) {
          el.scrollTop =
            el.scrollTop + elem.offsetHeight + elem.offsetHeight - calcScroll;
        }
      } else if ((dir = "up")) {
        calcScroll = elem.offsetTop + -el.scrollTop - top;
        if (
          top >
          elem.offsetTop + itemsContainerTop - el.scrollTop - elem.offsetHeight
        ) {
          el.scrollTop -= elem.offsetHeight - calcScroll;
        }
      }
    },
    setActive(dir) {
      let item;

      if (dir == "up") {
        if (this.indexActive == 0) return;
        this.indexActive--;
        item = this.list[this.indexActive];
      } else {
        if (this.indexActive == this.list.length) return;
        this.indexActive++;
        item = this.list[this.indexActive];
      }
      const pageinx = item.special ? item.page : null;
      this.activeBookIndex = pageinx;
      this.activeBook = item.id;
    },
    addKey() {
      // if (!this.$store.state.hasModalOpen) this.$refs.el.focus();
      // window.addEventListener("keydown", this.scrollList);
    },
    async clickBook(
      addToHistory = true,
      forceSameTab = false,
      forceNewTab = false
    ) {
      this.$store.state.homePage = false;
      if (!isGzirIndex(this.$store.state.currentActiveListIndex)) {
        let item =
          this.list[parseInt(this.$store.state.currentActiveListIndex)];

        if (item == undefined) return;
        let book;
        if (item.special) book = item.book;
        else book = item;
        let bookId = book.id;
        let page = -1;
        if (item.page) page = "P" + item.page;
        let extraData = {};
        if (book.fs != undefined && !this.isSpecialResults)
          extraData.fs = book.fs;

        //third param is if book should open in new tab. depends on user settings
        this.updateLastActive(
          parseInt(this.$store.state.currentActiveListIndex)
        );

        if (this.searchId !== "main") {
          this.$nextTick(() => {
            let list = this.$refs.el;
            list = list.querySelector(".list-book-inner");

            let elem = list.querySelector(
              `.item-book#freebook_${this.$store.state.currentActiveListIndex}`
            );
            if (elem) elem.click();
          });
          return;
        }

        open(bookId, page, null, extraData.fs, forceSameTab, forceNewTab);
      } else {
        let str = this.$store.state.currentActiveListIndex;
        let gzirInd = str.split(".")[1];
        let bookInd = str.split(".")[0];
        let list = this.$refs.el;
        list = list.querySelector(".list-book-inner");
        let gzir = list.querySelector(
          ".gzir#freebook_" + bookInd + "_" + (parseInt(gzirInd) - 1)
        );
        if (gzir) {
          gzir = gzir.querySelector(".gzirImg");
          if (gzir) gzir.click();
        }
      }
    },
  },
  mounted() {
    this.activeBook = this.getCurrentBook;
  },
};

function isGzirIndex(str) {
  return str.split(".").length === 2;
}
</script>

<style lang="scss" scoped>
.con {
  height: calc(100% - 27px);
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.itemTest {
  height: 10%;
  height: 100px;
  border: 1px solid;
  font-size: 25px;
  font-weight: bold;
  text-align: center;
  line-height: 100px;
}

.list-book {
  height: calc(100% - 33px);
  // height: 100%;
  // border-top: 2px solid rgba(0, 0, 0, 0.1);
  direction: ltr;
}
.test {
  background: red;
  // height: 300px;
}
</style>
